import { axios, Response } from '../index'
import { OperationalInfo } from './get-operator-by-id'

export type UpdateOperationalDTO = Omit<
  OperationalInfo,
  'id' | 'avatar' | 'accessProfiles'
> & { accessProfileIds: string[] }

const updateOperationalById = (
  operationalId: string,
  body: UpdateOperationalDTO
): Response<OperationalInfo> => {
  return axios.put(`/v1/operators/${operationalId}`, body)
}

export default updateOperationalById
